const COVERS = {
  wound: '/covers/wound.jpg',
  leadership: '/covers/leadership.jpg',
  leadership2: '/covers/leadership2.jpg',
  care: '/covers/care.jpg',
  palliative: '/covers/palliative.jpg',
  hygiene: '/covers/hygiene.jpg',
  geronto: '/covers/geronto.jpg',
  praxis: '/covers/praxis.jpg',
  study: '/covers/study.jpg',
};

export const HERO_IMAGE = '/dashboard_hero_bright.jpg';

const COURSE_INTROS = {
  'course-wundmanagement': 'Wunden verstehen, Teams führen — Verantwortung, die heilt.',
  'course-behandlungspflege-lg': 'Sicher handeln in der Behandlungspflege — Schritt für Schritt zur Routine.',
  'course-rezertifizierung-43b': 'Ein Jahr Erfahrung, aufgefrischt — Betreuung, die in Erinnerung bleibt.',
  'course-hygiene-infektion': 'Unsichtbares sichtbar machen — Hygiene als tägliche Haltung.',
  'course-haftung-delegation': 'Wer darf was? Klarheit für deinen Alltag — rechtssicher delegieren.',
  'course-gewaltpraevention': 'Ruhe bewahren, wenn es laut wird — Deeskalation mit Haltung.',
  'course-kommunikation': 'Worte, die tragen — Gespräche mit Angehörigen und im Team.',
  'course-wund-rezertifizierung': 'Dein Wundwissen, auf dem neuesten Stand — kompakt aufgefrischt.',
  'course-wundmanagement-pflegefachkraefte': 'Chronische Wunden versorgen — mit Wissen, das ankommt.',
  'course-palliativpflege': 'Würdevoll begleiten — Schmerz, Symptome, Kommunikation und Ethik.',
  'course-pdl-weiterbildung-teil1': 'Führen lernen — Grundlagen für deine Leitungsrolle.',
  'course-pdl-weiterbildung-teil2': 'Zahlen, Struktur, Klarheit — Abrechnung und Dokumentation im Griff.',
  'course-pdl-weiterbildung-teil3': 'Die Vertiefungsstufe — Einrichtungen strategisch und souverän leiten.',
  'course-weiterbildung-wundexperte': 'Vom Wissen zur Expertise — Wundtherapie auf höchstem Niveau.',
  'course-praxisanleiter': 'Wissen weitergeben — Menschen beim Wachsen begleiten.',
  'course-pflegeberater': 'Beraten mit Herz und Paragraf — §7a im Pflegealltag.',
  'course-hygienebeauftragter': 'Verantwortung für das Unsichtbare — Hygiene, die schützt.',
  'course-gerontopsychiatrie': 'Alte Menschen neu verstehen — Demenz, Depression, Delir.',
  'course-qualitaetsbeauftragter': 'Qualität ist kein Zufall — Prozesse, die Pflege besser machen.',
  'course-pflegehilfskraft': 'Dein Einstieg in die Pflege — Betreuung mit Herz und Handwerk.',
  'course-wundexperte-84': 'Wundversorgung von Grund auf — dein Fundament als Wundexperte.',
  'course-externenpruefung-pfa': 'Bereit für die Prüfung — Pflegefachassistenz souverän bestehen.',
  'course-intensivpflege-akip': 'Hochkomplex, hochmenschlich — außerklinische Intensivpflege.',
  'course-pflege-ki': 'Die KI schreibt, du entscheidest — dein Führerschein für sichere Pflege-Dokumentation.',
};

export function getCourseIntro(courseId = '', fallback = '') {
  return COURSE_INTROS[courseId] || fallback;
}

export function getCourseCover(courseId = '') {
  const id = courseId.toLowerCase();
  if (id.includes('pflege-ki')) return '/covers/course-pflege-ki.jpg';
  if (id.includes('wund')) return COVERS.wound;
  if (id.includes('pdl-weiterbildung-teil2')) return COVERS.leadership2;
  if (id.includes('pdl') || id.includes('qualitaet')) return COVERS.leadership;
  if (id.includes('palliativ')) return COVERS.palliative;
  if (id.includes('hygiene')) return COVERS.hygiene;
  if (id.includes('geronto')) return COVERS.geronto;
  if (id.includes('praxisanleiter') || id.includes('kommunikation') || id.includes('rezert')) return COVERS.praxis;
  if (id.includes('behandlungspflege') || id.includes('pflegehilfskraft') || id.includes('intensiv') || id.includes('pflegeberater') || id.includes('betreuung')) return COVERS.care;
  return COVERS.study;
}
